import React, { useState, useEffect } from "react";
import { Checkbox } from "@fluentui/react-components";

const CheckboxInputWarning = (props) => {
  const { label, checked, setChecked, checkStatus, isMilestone, StyleClass, disabled=false } = props;
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = () => {
    setChecked(!isChecked);
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <Checkbox
      className={`${StyleClass} checkboxWrapperWarning`}
      // id="checkbox"
      checked={isChecked}
      disabled={disabled}
      // checked={isChecked || checkStatus}
      onChange={handleChange}
      // onChange={(ev, data) => setChecked(data.checked)}
      label={label}
    />
  );
};

export default CheckboxInputWarning;
